/**
 * Blocks leaving a page with unsaved edits in two ways:
 * - In-app routes: Layout calls tryNavigateAway → page shows its own Modal.
 * - Refresh / close tab: beforeunload (browser confirmation; custom modals cannot run on unload).
 */

let activeGuard = null;

/**
 * @param {{ shouldBlock: () => boolean, prompt: (proceed: () => void) => void }} guard
 * @returns {() => void} unregister
 */
export function registerUnsavedNavigationGuard(guard) {
  activeGuard = guard;

  const onBeforeUnload = (e) => {
    if (!activeGuard?.shouldBlock?.()) return;
    e.preventDefault();
    // Legacy + modern browsers: non-empty returnValue triggers the leave confirmation.
    e.returnValue = "";
  };

  window.addEventListener("beforeunload", onBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", onBeforeUnload);
    if (activeGuard === guard) activeGuard = null;
  };
}

export function hasActiveUnsavedNavigationGuard() {
  return Boolean(activeGuard?.shouldBlock?.());
}

/**
 * @param {() => void} proceed
 */
export function tryNavigateAway(proceed) {
  if (!activeGuard?.shouldBlock?.()) {
    proceed();
    return;
  }
  activeGuard.prompt(proceed);
}
